import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  const _component_van_address_edit = _resolveComponent("van-address-edit");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_van_nav_bar, {
    title: "编辑收货地址",
    "left-arrow": "",
    onClickLeft: $setup.goBack,
    fixed: "",
    placeholder: ""
  }, null, 8, ["onClickLeft"]), _createVNode(_component_van_address_edit, {
    "area-list": $setup.areaList,
    "address-info": $setup.addData,
    "show-delete": $setup.showDel,
    "show-set-default": "",
    onSave: $setup.onSave,
    onDelete: $setup.onDelete
  }, null, 8, ["area-list", "address-info", "show-delete", "onSave", "onDelete"])], 64);
}